import { render, staticRenderFns } from "./MonthAndStaff.vue?vue&type=template&id=54d63d92&scoped=true"
import script from "./MonthAndStaff.vue?vue&type=script&lang=js"
export * from "./MonthAndStaff.vue?vue&type=script&lang=js"
import style0 from "./MonthAndStaff.vue?vue&type=style&index=0&id=54d63d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d63d92",
  null
  
)

export default component.exports